/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { BootstrapDialog } from '../../../../assets/style/globalStyle';
import {
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { NotificationManager } from 'react-notifications';
import InputMask from 'react-input-mask';

import { TextField, Grid, Autocomplete } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import configAxios from '../../../../services/configAxios';
import Iconify from '../../../../@core/theme/Iconify';
import palette from 'src/@core/theme/palette';
import { useEffect } from 'react';
import { isMobile } from 'react-device-detect';

const LinkOpening = (props) => {
  // const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });
  const [infosOpening, setInfosOpening] = useState({});
  const [rowsSelected, setRowsSelected] = useState({});
  const [weekUsed, setWeekUsed] = useState([]);
  const [selectedValue, setSelectedValue] = useState('1');
  const WeekDay = [
    {
      id: 0,
      label: '0001-Segunda-feira',
      name: 'Segunda-feira'
    },
    {
      id: 1,
      label: '0002-Terça-feira',
      name: 'Terça-feira'
    },
    {
      id: 2,
      label: '0003-Quarta-feira',
      name: 'Quarta-feira'
    },
    {
      id: 3,
      label: '0004-Quinta-feira',
      name: 'Quinta-feira'
    },
    {
      id: 4,
      label: '0005-Sexta-feira',
      name: 'Sexta-feira'
    },
    {
      id: 5,
      label: '0006-Sábado',
      name: 'Sábado'
    },
    {
      id: 6,
      label: '0007-Domingo',
      name: 'Domingo'
    }
  ];

  useEffect(() => {
    if (props.editMode === false) {
      setWeekUsed(WeekDay);
      setRowsSelected({});
      setInfosOpening({});
      setSelectedValue('1');
    } else {
      WeekDay.map((item, index) => {
        if (item.name === props.hoursInfos?.weekDay) {
          setWeekUsed([item]);
          setRowsSelected(item);
        }
      });
    }

    if (props.editMode === true) {
      setInfosOpening(props.hoursInfos);
    }
  }, [props]);

  //   Add Social Media to Partners
  function HandleSubmit(event) {
    event.preventDefault();
    let url = '';
    if (infosOpening) {
      if (props.editMode === true) {
        url = '/establishments/updateOpeningHours';
      } else {
        url = '/establishments/createOpeningHours';
      }
      configAxios
        .post(url, infosOpening)
        .then(() => {
          props.setOpenModal(false);
          props.functionGrid();
          NotificationManager.success(
            props.editMode === true
              ? 'Horário atualizado com sucesso!'
              : 'Horário vinculado com sucesso!',
            'Sucesso'
          );
          setInfosOpening({});
        })
        .catch(() => {
          NotificationManager.error(
            'Tivemos dificuldades para vincular as redes sociais! Tente novamente!',
            'Atenção'
          );
        });
    } else {
      NotificationManager.warning('Selecione as redes sociais que deseja vincular!', 'Atenção');
    }
  }

  function HandleInputChange(event, autocomplete) {
    if (autocomplete) {
      if (event) {
        setInfosOpening({
          ...infosOpening,
          weekDay: event.name,
          idEstablishment: props.otherInfos.id
        });
        setRowsSelected({
          label: event.label
        });
        return;
      }
      return;
    }
    setInfosOpening({ ...infosOpening, [event.target.name]: event.target.value });
  }

  function handleChange(event) {
    setSelectedValue(event.target.value);
  }

  const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 10,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired
  };

  return (
    <>
      <div>
        <BootstrapDialog
          onClose={() => {
            props.setOpenModal(false);
            props.functionGrid();
          }}
          aria-labelledby="customized-dialog-title"
          fullWidth
          maxWidth={'md'}
          open={props.openModal}>
          <BootstrapDialogTitle
            id="customized-dialog-title"
            style={{
              color: palette.primary.contrastText,
              input: { color: 'black' }
            }}
            onClose={() => {
              props.setOpenModal(false);
              props.functionGrid();
            }}>
            {props.editMode === true
              ? 'Editar horário de funcionamento no parceiro'
              : 'Vincular horário de funcionamento no parceiro'}
          </BootstrapDialogTitle>

          <form onSubmit={HandleSubmit}>
            <DialogContent dividers>
              <Grid
                container
                spacing={2}
                sx={{
                  mt: 1,
                  input: { color: palette.primary.contrastText }
                }}>
                <Grid item xs={5} md={5}>
                  <Autocomplete
                    sx={{ color: palette.primary.contrastText, input: { color: 'black' } }}
                    options={weekUsed}
                    renderOption={(props, option) => (
                      <li style={{ color: palette.primary.contrastText }} {...props}>
                        {option.label}
                      </li>
                    )}
                    isOptionEqualToValue={(option, value) =>
                      value ? option.label === value : option.label === ''
                    }
                    onChange={(event, value) => HandleInputChange(value, { autocomplete: true })}
                    value={rowsSelected.label || ''}
                    defaultValue=""
                    renderInput={(params) => (
                      <TextField
                        sx={{ color: palette.primary.contrastText, input: { color: 'black' } }}
                        {...params}
                        label="Dia da Semana"
                        name="label"
                        fullWidth
                        size="small"
                        variant="outlined"
                        required
                      />
                    )}
                  />
                </Grid>

                <FormControl sx={{ marginLeft: 5 }}>
                  <FormLabel>Horário de funcionamento</FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={selectedValue}
                    onChange={handleChange}
                    defaultValue="1"
                    sx={{ color: palette.primary.contrastText }}>
                    <FormControlLabel value="1" control={<Radio />} label="Horário Comercial" />
                    <FormControlLabel value="2" control={<Radio />} label="Personalizado" />
                  </RadioGroup>
                </FormControl>

                <Grid
                  item
                  xs={3}
                  sx={{ color: palette.primary.contrastText, input: { color: 'black' } }}>
                  <InputLabel
                    id="label"
                    sx={isMobile ? { fontSize: '13px', mt: -1 } : { fontSize: '13px', mt: -1 }}>
                    Alunos por horario
                  </InputLabel>
                  <Select
                    sx={{ color: palette.primary.contrastText, input: { color: 'black' } }}
                    name="userPerClass"
                    fullWidth
                    size="small"
                    required
                    value={infosOpening.userPerClass || ''}
                    onChange={(event) => HandleInputChange(event)}>
                    <MenuItem sx={{ color: palette.primary.contrastText }} value={'0'}>
                      Não especificado
                    </MenuItem>
                    <MenuItem sx={{ color: palette.primary.contrastText }} value={'1'}>
                      1
                    </MenuItem>
                    <MenuItem sx={{ color: palette.primary.contrastText }} value={'2'}>
                      2
                    </MenuItem>
                    <MenuItem sx={{ color: palette.primary.contrastText }} value={'3'}>
                      3
                    </MenuItem>
                    <MenuItem sx={{ color: palette.primary.contrastText }} value={'4'}>
                      4
                    </MenuItem>
                    <MenuItem sx={{ color: palette.primary.contrastText }} value={'5'}>
                      5
                    </MenuItem>
                    <MenuItem sx={{ color: palette.primary.contrastText }} value={'6'}>
                      6
                    </MenuItem>
                    <MenuItem sx={{ color: palette.primary.contrastText }} value={'7'}>
                      7
                    </MenuItem>
                    <MenuItem sx={{ color: palette.primary.contrastText }} value={'8'}>
                      8
                    </MenuItem>
                    <MenuItem sx={{ color: palette.primary.contrastText }} value={'9'}>
                      9
                    </MenuItem>
                    <MenuItem sx={{ color: palette.primary.contrastText }} value={'10'}>
                      10
                    </MenuItem>
                    <MenuItem sx={{ color: palette.primary.contrastText }} value={'11'}>
                      11
                    </MenuItem>
                    <MenuItem sx={{ color: palette.primary.contrastText }} value={'12'}>
                      12
                    </MenuItem>
                    <MenuItem sx={{ color: palette.primary.contrastText }} value={'13'}>
                      13
                    </MenuItem>
                    <MenuItem sx={{ color: palette.primary.contrastText }} value={'14'}>
                      14
                    </MenuItem>
                    <MenuItem sx={{ color: palette.primary.contrastText }} value={'15'}>
                      15
                    </MenuItem>
                  </Select>
                </Grid>
              </Grid>

              {selectedValue === '1' ? (
                <Grid
                  container
                  spacing={2}
                  sx={{
                    mt: 1,
                    input: { color: palette.primary.contrastText }
                  }}>
                  <Grid
                    item
                    xs={12}
                    md={2}
                    sx={{ color: palette.primary.contrastText, input: { color: 'black' } }}>
                    <InputMask
                      mask="99:99"
                      value={infosOpening.openMorning || ''}
                      onChange={(event) => HandleInputChange(event)}>
                      {() => (
                        <TextField
                          name="openMorning"
                          fullWidth
                          label="Início"
                          variant="outlined"
                          size="small"
                          required
                        />
                      )}
                    </InputMask>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={2}
                    sx={{ color: palette.primary.contrastText, input: { color: 'black' } }}>
                    <InputMask
                      mask="99:99"
                      value={infosOpening.closeMorning || ''}
                      onChange={(event) => HandleInputChange(event)}>
                      {() => (
                        <TextField
                          name="closeMorning"
                          fullWidth
                          label="Fim"
                          variant="outlined"
                          size="small"
                          required
                        />
                      )}
                    </InputMask>
                  </Grid>
                </Grid>
              ) : (
                <Grid
                  container
                  spacing={2}
                  sx={{
                    mt: 1,
                    input: { color: palette.primary.contrastText }
                  }}>
                  <Grid
                    item
                    xs={12}
                    md={2}
                    sx={{ color: palette.primary.contrastText, input: { color: 'black' } }}>
                    <InputMask
                      mask="99:99"
                      value={infosOpening.openMorning || ''}
                      onChange={(event) => HandleInputChange(event)}>
                      {() => (
                        <TextField
                          name="openMorning"
                          fullWidth
                          label="Ini. manhã"
                          variant="outlined"
                          size="small"
                          required
                        />
                      )}
                    </InputMask>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={2}
                    sx={{ color: palette.primary.contrastText, input: { color: 'black' } }}>
                    <InputMask
                      mask="99:99"
                      value={infosOpening.closeMorning || ''}
                      onChange={(event) => HandleInputChange(event)}>
                      {() => (
                        <TextField
                          name="closeMorning"
                          fullWidth
                          label="Fim manhã"
                          variant="outlined"
                          size="small"
                          required
                        />
                      )}
                    </InputMask>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={2}
                    sx={{ color: palette.primary.contrastText, input: { color: 'black' } }}>
                    <InputMask
                      mask="99:99"
                      value={infosOpening.openAfternoon || ''}
                      onChange={(event) => HandleInputChange(event)}>
                      {() => (
                        <TextField
                          name="openAfternoon"
                          fullWidth
                          label="Ini. tarde"
                          variant="outlined"
                          size="small"
                        />
                      )}
                    </InputMask>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={2}
                    sx={{ color: palette.primary.contrastText, input: { color: 'black' } }}>
                    <InputMask
                      mask="99:99"
                      value={infosOpening.closeAfternoon || ''}
                      onChange={(event) => HandleInputChange(event)}>
                      {() => (
                        <TextField
                          name="closeAfternoon"
                          fullWidth
                          label="Fim Tarde"
                          variant="outlined"
                          size="small"
                        />
                      )}
                    </InputMask>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={2}
                    sx={{ color: palette.primary.contrastText, input: { color: 'black' } }}>
                    <InputMask
                      mask="99:99"
                      value={infosOpening.openNight || ''}
                      onChange={(event) => HandleInputChange(event)}>
                      {() => (
                        <TextField
                          name="openNight"
                          fullWidth
                          label="Ini. noite"
                          variant="outlined"
                          size="small"
                          required
                        />
                      )}
                    </InputMask>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={2}
                    sx={{ color: palette.primary.contrastText, input: { color: 'black' } }}>
                    <InputMask
                      mask="99:99"
                      value={infosOpening.closeNight || ''}
                      onChange={(event) => HandleInputChange(event)}>
                      {() => (
                        <TextField
                          name="closeNight"
                          fullWidth
                          label="Fim noite"
                          variant="outlined"
                          size="small"
                          required
                        />
                      )}
                    </InputMask>
                  </Grid>
                </Grid>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                type="submit"
                variant="contained"
                size="medium"
                color="success"
                startIcon={<Iconify icon="eva:save-fill" />}>
                {props.editMode === true ? 'Editar' : 'Vincular'}
              </Button>
              <Button
                onClick={() => {
                  props.setOpenModal(false);
                  props.functionGrid();
                }}
                color="error"
                variant="contained"
                startIcon={<Iconify icon="eva:close-circle-fill" />}>
                Cancelar
              </Button>
            </DialogActions>
          </form>
        </BootstrapDialog>
      </div>
    </>
  );
};

export default LinkOpening;
